import React from 'react';

import DataReportHistory from '../components/data-report-history';

class DataReportHistoryPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<DataReportHistory />
			</div>
		)
	}

}

export default DataReportHistoryPage;


// WEBPACK FOOTER //
// ./src/containers/data-report-history-page.js